unit View.Itens_Cupons.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewItens_CuponsList = class(TForm)
    btNew: TButton;
    Itens_CuponsDataset: TXDataWebDataSet;
    Itens_CuponsDatasetid: TIntegerField;
    Itens_CuponsDatasetaliado_id: TIntegerField;
    Itens_CuponsDatasetdata_base_id: TIntegerField;
    Itens_CuponsDatasetcupons_id: TIntegerField;
    Itens_CuponsDatasetproduto_id: TIntegerField;
    Itens_CuponsDatasetunidade_id: TIntegerField;
    Itens_CuponsDatasetitem: TIntegerField;
    Itens_CuponsDatasetcfop_cfop: TStringField;
    Itens_CuponsDatasetquantidade: TFloatField;
    Itens_CuponsDatasetproduto_preco: TFloatField;
    Itens_CuponsDatasetmargem_acrescimo: TFloatField;
    Itens_CuponsDatasetvalor_acrescimo: TFloatField;
    Itens_CuponsDatasetmargem_desconto: TFloatField;
    Itens_CuponsDatasetvalor_desconto: TFloatField;
    Itens_CuponsDatasetvalor_total: TFloatField;
    Itens_CuponsDatasetaliquota_icms: TFloatField;
    Itens_CuponsDatasetvalor_icms: TFloatField;
    Itens_CuponsDatasetaliquota_icms_red: TFloatField;
    Itens_CuponsDatasetvalor_icms_red: TFloatField;
    Itens_CuponsDatasetvalor_base_calculo_icms: TFloatField;
    Itens_CuponsDatasetcst_id: TStringField;
    Itens_CuponsDatasetvalor_base_calculo_pis: TFloatField;
    Itens_CuponsDatasetvalor_pis: TFloatField;
    Itens_CuponsDatasetvalor_base_calculo_cofins: TFloatField;
    Itens_CuponsDatasetvalor_cofins: TFloatField;
    Itens_CuponsDatasetcsosn_id: TStringField;
    Itens_CuponsDatasetaliquota_pis: TFloatField;
    Itens_CuponsDatasetaliquota_cofins: TFloatField;
    Itens_CuponsDatasetcst_pis_id: TStringField;
    Itens_CuponsDatasetcst_cofins_id: TStringField;
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id: TStringField;
    Itens_CuponsDatasetaliquota_id: TIntegerField;
    Itens_CuponsDatasetproduto_preco_custo: TFloatField;
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque: TIntegerField;
    Itens_CuponsDatasetfuncionario_id: TIntegerField;
    Itens_CuponsDatasetitem_movimenta_estoque: TBooleanField;
    Itens_CuponsDatasetquantidade_embalagem: TFloatField;
    Itens_CuponsDatasetgrade_produto_id: TIntegerField;
    Itens_CuponsDatasetproduto_nome: TStringField;
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque: TFloatField;
    Itens_CuponsDatasetscan_promocoes_id: TIntegerField;
    Itens_CuponsDatasetvalor_desconto_scanntech: TFloatField;
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms: TFloatField;
    Itens_CuponsDatasetaliquota_fcp_icms: TFloatField;
    Itens_CuponsDatasetvalor_fcp_icms: TFloatField;
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida: TFloatField;
    Itens_CuponsDatasetaliquota_fcp_retida: TFloatField;
    Itens_CuponsDatasetvalor_fcp_retida: TFloatField;
    Itens_CuponsDatasetcodigo_interno: TIntegerField;
    Itens_CuponsDatasetexcluido: TBooleanField;
    Itens_CuponsDatasetinclusao: TDateTimeField;
    Itens_CuponsDatasetalteracao: TDateTimeField;
    Itens_CuponsDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewItens_CuponsList: TFViewItens_CuponsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewItens_CuponsList }

procedure TFViewItens_CuponsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewItens_CuponsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewItens_CuponsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewItens_CuponsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewItens_CuponsList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewItens_CuponsList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewItens_CuponsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Itens_CuponsDataset.Connection.Model.DefaultSchema.FindEntityType(Itens_CuponsDataset.EntitySetName),
      Itens_CuponsDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewItens_CuponsList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('itens_cupons', 'active');
  TUtils.SetValorDicionarioClasses('cupons_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cupons', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Itens_CuponsDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewItens_CuponsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.itens_cupons.list.pagination.info');
  btNew := TButton.Create('view.itens_cupons.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.itens_cupons.list.table');
  cbPageSize := TComboBox.Create('view.itens_cupons.list.cbPageSize');
  edSearch := TEdit.Create('view.itens_cupons.list.search');
  lcPaginator := TListControl.Create('view.itens_cupons.list.pagination');
  Itens_CuponsDataset := TXDataWebDataSet.Create(Self);
  Itens_CuponsDatasetid := TIntegerField.Create(Self);
  Itens_CuponsDatasetaliado_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetdata_base_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetcupons_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetproduto_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetunidade_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetitem := TIntegerField.Create(Self);
  Itens_CuponsDatasetcfop_cfop := TStringField.Create(Self);
  Itens_CuponsDatasetquantidade := TFloatField.Create(Self);
  Itens_CuponsDatasetproduto_preco := TFloatField.Create(Self);
  Itens_CuponsDatasetmargem_acrescimo := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_acrescimo := TFloatField.Create(Self);
  Itens_CuponsDatasetmargem_desconto := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_desconto := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_total := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_icms_red := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_icms_red := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetcst_id := TStringField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_pis := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_pis := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_cofins := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_cofins := TFloatField.Create(Self);
  Itens_CuponsDatasetcsosn_id := TStringField.Create(Self);
  Itens_CuponsDatasetaliquota_pis := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_cofins := TFloatField.Create(Self);
  Itens_CuponsDatasetcst_pis_id := TStringField.Create(Self);
  Itens_CuponsDatasetcst_cofins_id := TStringField.Create(Self);
  Itens_CuponsDatasetcodigo_natureza_pis_cofins_id := TStringField.Create(Self);
  Itens_CuponsDatasetaliquota_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetproduto_preco_custo := TFloatField.Create(Self);
  Itens_CuponsDatasetcodigo_produto_movimenta_estoque := TIntegerField.Create(Self);
  Itens_CuponsDatasetfuncionario_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetitem_movimenta_estoque := TBooleanField.Create(Self);
  Itens_CuponsDatasetquantidade_embalagem := TFloatField.Create(Self);
  Itens_CuponsDatasetgrade_produto_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetproduto_nome := TStringField.Create(Self);
  Itens_CuponsDatasetitem_quantidade_movimenta_estoque := TFloatField.Create(Self);
  Itens_CuponsDatasetscan_promocoes_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetvalor_desconto_scanntech := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_fcp_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_fcp_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_fcp_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_fcp_retida := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_fcp_retida := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_fcp_retida := TFloatField.Create(Self);
  Itens_CuponsDatasetcodigo_interno := TIntegerField.Create(Self);
  Itens_CuponsDatasetexcluido := TBooleanField.Create(Self);
  Itens_CuponsDatasetinclusao := TDateTimeField.Create(Self);
  Itens_CuponsDatasetalteracao := TDateTimeField.Create(Self);
  Itens_CuponsDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Itens_CuponsDataset.BeforeLoadDFMValues;
  Itens_CuponsDatasetid.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliado_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetdata_base_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetcupons_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetproduto_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetunidade_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetitem.BeforeLoadDFMValues;
  Itens_CuponsDatasetcfop_cfop.BeforeLoadDFMValues;
  Itens_CuponsDatasetquantidade.BeforeLoadDFMValues;
  Itens_CuponsDatasetproduto_preco.BeforeLoadDFMValues;
  Itens_CuponsDatasetmargem_acrescimo.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_acrescimo.BeforeLoadDFMValues;
  Itens_CuponsDatasetmargem_desconto.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_desconto.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_total.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_icms_red.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_icms_red.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetcst_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_pis.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_pis.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_cofins.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_cofins.BeforeLoadDFMValues;
  Itens_CuponsDatasetcsosn_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_pis.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_cofins.BeforeLoadDFMValues;
  Itens_CuponsDatasetcst_pis_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetcst_cofins_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetproduto_preco_custo.BeforeLoadDFMValues;
  Itens_CuponsDatasetcodigo_produto_movimenta_estoque.BeforeLoadDFMValues;
  Itens_CuponsDatasetfuncionario_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetitem_movimenta_estoque.BeforeLoadDFMValues;
  Itens_CuponsDatasetquantidade_embalagem.BeforeLoadDFMValues;
  Itens_CuponsDatasetgrade_produto_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetproduto_nome.BeforeLoadDFMValues;
  Itens_CuponsDatasetitem_quantidade_movimenta_estoque.BeforeLoadDFMValues;
  Itens_CuponsDatasetscan_promocoes_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_desconto_scanntech.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_fcp_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_fcp_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_fcp_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_fcp_retida.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_fcp_retida.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_fcp_retida.BeforeLoadDFMValues;
  Itens_CuponsDatasetcodigo_interno.BeforeLoadDFMValues;
  Itens_CuponsDatasetexcluido.BeforeLoadDFMValues;
  Itens_CuponsDatasetinclusao.BeforeLoadDFMValues;
  Itens_CuponsDatasetalteracao.BeforeLoadDFMValues;
  Itens_CuponsDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewItens_CuponsList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cupons_id';
      Title := 'cupons_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_id';
      Title := 'produto_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'unidade_id';
      Title := 'unidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'item';
      Title := 'item';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_cfop';
      Title := 'cfop_cfop';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade';
      Title := 'quantidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_preco';
      Title := 'produto_preco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'margem_acrescimo';
      Title := 'margem_acrescimo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_acrescimo';
      Title := 'valor_acrescimo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'margem_desconto';
      Title := 'margem_desconto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_desconto';
      Title := 'valor_desconto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'valor_total';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_icms';
      Title := 'aliquota_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms';
      Title := 'valor_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_icms_red';
      Title := 'aliquota_icms_red';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_red';
      Title := 'valor_icms_red';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_icms';
      Title := 'valor_base_calculo_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_id';
      Title := 'cst_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_pis';
      Title := 'valor_base_calculo_pis';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_pis';
      Title := 'valor_pis';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_cofins';
      Title := 'valor_base_calculo_cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_cofins';
      Title := 'valor_cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'csosn_id';
      Title := 'csosn_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_pis';
      Title := 'aliquota_pis';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_cofins';
      Title := 'aliquota_cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_pis_id';
      Title := 'cst_pis_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_cofins_id';
      Title := 'cst_cofins_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_natureza_pis_cofins_id';
      Title := 'codigo_natureza_pis_cofins_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_id';
      Title := 'aliquota_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_preco_custo';
      Title := 'produto_preco_custo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_produto_movimenta_estoque';
      Title := 'codigo_produto_movimenta_estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario_id';
      Title := 'funcionario_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'item_movimenta_estoque';
      Title := 'item_movimenta_estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade_embalagem';
      Title := 'quantidade_embalagem';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'grade_produto_id';
      Title := 'grade_produto_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_nome';
      Title := 'produto_nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'item_quantidade_movimenta_estoque';
      Title := 'item_quantidade_movimenta_estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'scan_promocoes_id';
      Title := 'scan_promocoes_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_desconto_scanntech';
      Title := 'valor_desconto_scanntech';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_fcp_icms';
      Title := 'valor_base_calculo_fcp_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_fcp_icms';
      Title := 'aliquota_fcp_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_fcp_icms';
      Title := 'valor_fcp_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_calculo_fcp_retida';
      Title := 'valor_base_calculo_fcp_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_fcp_retida';
      Title := 'aliquota_fcp_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_fcp_retida';
      Title := 'valor_fcp_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Itens_CuponsDataset.SetParentComponent(Self);
    Itens_CuponsDataset.Name := 'Itens_CuponsDataset';
    Itens_CuponsDataset.EntitySetName := 'Itens_Cupons';
    Itens_CuponsDataset.Connection := DMConnection.ApiConnection;
    Itens_CuponsDataset.Left := 72;
    Itens_CuponsDataset.Top := 144;
    Itens_CuponsDatasetid.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetid.Name := 'Itens_CuponsDatasetid';
    Itens_CuponsDatasetid.FieldName := 'id';
    Itens_CuponsDatasetid.Required := True;
    Itens_CuponsDatasetaliado_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliado_id.Name := 'Itens_CuponsDatasetaliado_id';
    Itens_CuponsDatasetaliado_id.FieldName := 'aliado_id';
    Itens_CuponsDatasetaliado_id.Required := True;
    Itens_CuponsDatasetdata_base_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetdata_base_id.Name := 'Itens_CuponsDatasetdata_base_id';
    Itens_CuponsDatasetdata_base_id.FieldName := 'data_base_id';
    Itens_CuponsDatasetdata_base_id.Required := True;
    Itens_CuponsDatasetcupons_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcupons_id.Name := 'Itens_CuponsDatasetcupons_id';
    Itens_CuponsDatasetcupons_id.FieldName := 'cupons_id';
    Itens_CuponsDatasetcupons_id.Required := True;
    Itens_CuponsDatasetproduto_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetproduto_id.Name := 'Itens_CuponsDatasetproduto_id';
    Itens_CuponsDatasetproduto_id.FieldName := 'produto_id';
    Itens_CuponsDatasetproduto_id.Required := True;
    Itens_CuponsDatasetunidade_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetunidade_id.Name := 'Itens_CuponsDatasetunidade_id';
    Itens_CuponsDatasetunidade_id.FieldName := 'unidade_id';
    Itens_CuponsDatasetitem.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetitem.Name := 'Itens_CuponsDatasetitem';
    Itens_CuponsDatasetitem.FieldName := 'item';
    Itens_CuponsDatasetcfop_cfop.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcfop_cfop.Name := 'Itens_CuponsDatasetcfop_cfop';
    Itens_CuponsDatasetcfop_cfop.FieldName := 'cfop_cfop';
    Itens_CuponsDatasetcfop_cfop.Required := True;
    Itens_CuponsDatasetcfop_cfop.Size := 255;
    Itens_CuponsDatasetquantidade.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetquantidade.Name := 'Itens_CuponsDatasetquantidade';
    Itens_CuponsDatasetquantidade.FieldName := 'quantidade';
    Itens_CuponsDatasetproduto_preco.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetproduto_preco.Name := 'Itens_CuponsDatasetproduto_preco';
    Itens_CuponsDatasetproduto_preco.FieldName := 'produto_preco';
    Itens_CuponsDatasetmargem_acrescimo.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetmargem_acrescimo.Name := 'Itens_CuponsDatasetmargem_acrescimo';
    Itens_CuponsDatasetmargem_acrescimo.FieldName := 'margem_acrescimo';
    Itens_CuponsDatasetvalor_acrescimo.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_acrescimo.Name := 'Itens_CuponsDatasetvalor_acrescimo';
    Itens_CuponsDatasetvalor_acrescimo.FieldName := 'valor_acrescimo';
    Itens_CuponsDatasetmargem_desconto.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetmargem_desconto.Name := 'Itens_CuponsDatasetmargem_desconto';
    Itens_CuponsDatasetmargem_desconto.FieldName := 'margem_desconto';
    Itens_CuponsDatasetvalor_desconto.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_desconto.Name := 'Itens_CuponsDatasetvalor_desconto';
    Itens_CuponsDatasetvalor_desconto.FieldName := 'valor_desconto';
    Itens_CuponsDatasetvalor_total.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_total.Name := 'Itens_CuponsDatasetvalor_total';
    Itens_CuponsDatasetvalor_total.FieldName := 'valor_total';
    Itens_CuponsDatasetvalor_total.Required := True;
    Itens_CuponsDatasetaliquota_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_icms.Name := 'Itens_CuponsDatasetaliquota_icms';
    Itens_CuponsDatasetaliquota_icms.FieldName := 'aliquota_icms';
    Itens_CuponsDatasetvalor_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_icms.Name := 'Itens_CuponsDatasetvalor_icms';
    Itens_CuponsDatasetvalor_icms.FieldName := 'valor_icms';
    Itens_CuponsDatasetaliquota_icms_red.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_icms_red.Name := 'Itens_CuponsDatasetaliquota_icms_red';
    Itens_CuponsDatasetaliquota_icms_red.FieldName := 'aliquota_icms_red';
    Itens_CuponsDatasetvalor_icms_red.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_icms_red.Name := 'Itens_CuponsDatasetvalor_icms_red';
    Itens_CuponsDatasetvalor_icms_red.FieldName := 'valor_icms_red';
    Itens_CuponsDatasetvalor_base_calculo_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_icms.Name := 'Itens_CuponsDatasetvalor_base_calculo_icms';
    Itens_CuponsDatasetvalor_base_calculo_icms.FieldName := 'valor_base_calculo_icms';
    Itens_CuponsDatasetcst_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcst_id.Name := 'Itens_CuponsDatasetcst_id';
    Itens_CuponsDatasetcst_id.FieldName := 'cst_id';
    Itens_CuponsDatasetcst_id.Size := 255;
    Itens_CuponsDatasetvalor_base_calculo_pis.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_pis.Name := 'Itens_CuponsDatasetvalor_base_calculo_pis';
    Itens_CuponsDatasetvalor_base_calculo_pis.FieldName := 'valor_base_calculo_pis';
    Itens_CuponsDatasetvalor_pis.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_pis.Name := 'Itens_CuponsDatasetvalor_pis';
    Itens_CuponsDatasetvalor_pis.FieldName := 'valor_pis';
    Itens_CuponsDatasetvalor_base_calculo_cofins.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_cofins.Name := 'Itens_CuponsDatasetvalor_base_calculo_cofins';
    Itens_CuponsDatasetvalor_base_calculo_cofins.FieldName := 'valor_base_calculo_cofins';
    Itens_CuponsDatasetvalor_cofins.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_cofins.Name := 'Itens_CuponsDatasetvalor_cofins';
    Itens_CuponsDatasetvalor_cofins.FieldName := 'valor_cofins';
    Itens_CuponsDatasetcsosn_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcsosn_id.Name := 'Itens_CuponsDatasetcsosn_id';
    Itens_CuponsDatasetcsosn_id.FieldName := 'csosn_id';
    Itens_CuponsDatasetcsosn_id.Size := 255;
    Itens_CuponsDatasetaliquota_pis.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_pis.Name := 'Itens_CuponsDatasetaliquota_pis';
    Itens_CuponsDatasetaliquota_pis.FieldName := 'aliquota_pis';
    Itens_CuponsDatasetaliquota_cofins.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_cofins.Name := 'Itens_CuponsDatasetaliquota_cofins';
    Itens_CuponsDatasetaliquota_cofins.FieldName := 'aliquota_cofins';
    Itens_CuponsDatasetcst_pis_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcst_pis_id.Name := 'Itens_CuponsDatasetcst_pis_id';
    Itens_CuponsDatasetcst_pis_id.FieldName := 'cst_pis_id';
    Itens_CuponsDatasetcst_pis_id.Size := 255;
    Itens_CuponsDatasetcst_cofins_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcst_cofins_id.Name := 'Itens_CuponsDatasetcst_cofins_id';
    Itens_CuponsDatasetcst_cofins_id.FieldName := 'cst_cofins_id';
    Itens_CuponsDatasetcst_cofins_id.Size := 255;
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.Name := 'Itens_CuponsDatasetcodigo_natureza_pis_cofins_id';
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.FieldName := 'codigo_natureza_pis_cofins_id';
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.Size := 255;
    Itens_CuponsDatasetaliquota_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_id.Name := 'Itens_CuponsDatasetaliquota_id';
    Itens_CuponsDatasetaliquota_id.FieldName := 'aliquota_id';
    Itens_CuponsDatasetproduto_preco_custo.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetproduto_preco_custo.Name := 'Itens_CuponsDatasetproduto_preco_custo';
    Itens_CuponsDatasetproduto_preco_custo.FieldName := 'produto_preco_custo';
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque.Name := 'Itens_CuponsDatasetcodigo_produto_movimenta_estoque';
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque.FieldName := 'codigo_produto_movimenta_estoque';
    Itens_CuponsDatasetfuncionario_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetfuncionario_id.Name := 'Itens_CuponsDatasetfuncionario_id';
    Itens_CuponsDatasetfuncionario_id.FieldName := 'funcionario_id';
    Itens_CuponsDatasetitem_movimenta_estoque.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetitem_movimenta_estoque.Name := 'Itens_CuponsDatasetitem_movimenta_estoque';
    Itens_CuponsDatasetitem_movimenta_estoque.FieldName := 'item_movimenta_estoque';
    Itens_CuponsDatasetitem_movimenta_estoque.Required := True;
    Itens_CuponsDatasetquantidade_embalagem.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetquantidade_embalagem.Name := 'Itens_CuponsDatasetquantidade_embalagem';
    Itens_CuponsDatasetquantidade_embalagem.FieldName := 'quantidade_embalagem';
    Itens_CuponsDatasetgrade_produto_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetgrade_produto_id.Name := 'Itens_CuponsDatasetgrade_produto_id';
    Itens_CuponsDatasetgrade_produto_id.FieldName := 'grade_produto_id';
    Itens_CuponsDatasetproduto_nome.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetproduto_nome.Name := 'Itens_CuponsDatasetproduto_nome';
    Itens_CuponsDatasetproduto_nome.FieldName := 'produto_nome';
    Itens_CuponsDatasetproduto_nome.Size := 255;
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque.Name := 'Itens_CuponsDatasetitem_quantidade_movimenta_estoque';
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque.FieldName := 'item_quantidade_movimenta_estoque';
    Itens_CuponsDatasetscan_promocoes_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetscan_promocoes_id.Name := 'Itens_CuponsDatasetscan_promocoes_id';
    Itens_CuponsDatasetscan_promocoes_id.FieldName := 'scan_promocoes_id';
    Itens_CuponsDatasetvalor_desconto_scanntech.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_desconto_scanntech.Name := 'Itens_CuponsDatasetvalor_desconto_scanntech';
    Itens_CuponsDatasetvalor_desconto_scanntech.FieldName := 'valor_desconto_scanntech';
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms.Name := 'Itens_CuponsDatasetvalor_base_calculo_fcp_icms';
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms.FieldName := 'valor_base_calculo_fcp_icms';
    Itens_CuponsDatasetaliquota_fcp_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_fcp_icms.Name := 'Itens_CuponsDatasetaliquota_fcp_icms';
    Itens_CuponsDatasetaliquota_fcp_icms.FieldName := 'aliquota_fcp_icms';
    Itens_CuponsDatasetvalor_fcp_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_fcp_icms.Name := 'Itens_CuponsDatasetvalor_fcp_icms';
    Itens_CuponsDatasetvalor_fcp_icms.FieldName := 'valor_fcp_icms';
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida.Name := 'Itens_CuponsDatasetvalor_base_calculo_fcp_retida';
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida.FieldName := 'valor_base_calculo_fcp_retida';
    Itens_CuponsDatasetaliquota_fcp_retida.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_fcp_retida.Name := 'Itens_CuponsDatasetaliquota_fcp_retida';
    Itens_CuponsDatasetaliquota_fcp_retida.FieldName := 'aliquota_fcp_retida';
    Itens_CuponsDatasetvalor_fcp_retida.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_fcp_retida.Name := 'Itens_CuponsDatasetvalor_fcp_retida';
    Itens_CuponsDatasetvalor_fcp_retida.FieldName := 'valor_fcp_retida';
    Itens_CuponsDatasetcodigo_interno.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcodigo_interno.Name := 'Itens_CuponsDatasetcodigo_interno';
    Itens_CuponsDatasetcodigo_interno.FieldName := 'codigo_interno';
    Itens_CuponsDatasetcodigo_interno.Required := True;
    Itens_CuponsDatasetexcluido.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetexcluido.Name := 'Itens_CuponsDatasetexcluido';
    Itens_CuponsDatasetexcluido.FieldName := 'excluido';
    Itens_CuponsDatasetinclusao.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetinclusao.Name := 'Itens_CuponsDatasetinclusao';
    Itens_CuponsDatasetinclusao.FieldName := 'inclusao';
    Itens_CuponsDatasetalteracao.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetalteracao.Name := 'Itens_CuponsDatasetalteracao';
    Itens_CuponsDatasetalteracao.FieldName := 'alteracao';
    Itens_CuponsDatasetexclusao.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetexclusao.Name := 'Itens_CuponsDatasetexclusao';
    Itens_CuponsDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Itens_CuponsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Itens_CuponsDataset.AfterLoadDFMValues;
    Itens_CuponsDatasetid.AfterLoadDFMValues;
    Itens_CuponsDatasetaliado_id.AfterLoadDFMValues;
    Itens_CuponsDatasetdata_base_id.AfterLoadDFMValues;
    Itens_CuponsDatasetcupons_id.AfterLoadDFMValues;
    Itens_CuponsDatasetproduto_id.AfterLoadDFMValues;
    Itens_CuponsDatasetunidade_id.AfterLoadDFMValues;
    Itens_CuponsDatasetitem.AfterLoadDFMValues;
    Itens_CuponsDatasetcfop_cfop.AfterLoadDFMValues;
    Itens_CuponsDatasetquantidade.AfterLoadDFMValues;
    Itens_CuponsDatasetproduto_preco.AfterLoadDFMValues;
    Itens_CuponsDatasetmargem_acrescimo.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_acrescimo.AfterLoadDFMValues;
    Itens_CuponsDatasetmargem_desconto.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_desconto.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_total.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_icms_red.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_icms_red.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetcst_id.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_pis.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_pis.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_cofins.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_cofins.AfterLoadDFMValues;
    Itens_CuponsDatasetcsosn_id.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_pis.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_cofins.AfterLoadDFMValues;
    Itens_CuponsDatasetcst_pis_id.AfterLoadDFMValues;
    Itens_CuponsDatasetcst_cofins_id.AfterLoadDFMValues;
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_id.AfterLoadDFMValues;
    Itens_CuponsDatasetproduto_preco_custo.AfterLoadDFMValues;
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque.AfterLoadDFMValues;
    Itens_CuponsDatasetfuncionario_id.AfterLoadDFMValues;
    Itens_CuponsDatasetitem_movimenta_estoque.AfterLoadDFMValues;
    Itens_CuponsDatasetquantidade_embalagem.AfterLoadDFMValues;
    Itens_CuponsDatasetgrade_produto_id.AfterLoadDFMValues;
    Itens_CuponsDatasetproduto_nome.AfterLoadDFMValues;
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque.AfterLoadDFMValues;
    Itens_CuponsDatasetscan_promocoes_id.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_desconto_scanntech.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_fcp_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_fcp_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_fcp_retida.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_fcp_retida.AfterLoadDFMValues;
    Itens_CuponsDatasetcodigo_interno.AfterLoadDFMValues;
    Itens_CuponsDatasetexcluido.AfterLoadDFMValues;
    Itens_CuponsDatasetinclusao.AfterLoadDFMValues;
    Itens_CuponsDatasetalteracao.AfterLoadDFMValues;
    Itens_CuponsDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
